<table>
  <thead>
      <tr>
          <th class="subtable short">{{'global.pais' | translate}}</th>
          <th class="subtable short">{{'usuarios.productor.table.tabs.denominaciones.denominacion' | translate}}</th>
          <th class="subtable actions">
            <i class="fas fa-plus" *ngIf="this.role === 'Administrador' || this.claims.includes('PROD_PD_Ins')"
                (click)="new=true;editables=''" title="{{'usuarios.productor.table.tabs.denominaciones.tituloNew' | translate}}"></i>
          </th>
      </tr>
  </thead>
  <tbody>
      <app-prod-pd-new-edit class="component-in-row" *ngIf="new" [editable]="true" (close)="new=$event" [productorId]="productorId"
      (refresh)="refresh($event)" (editableChanged)="editableChanged($event)" (pushMessage)="pushMessage.emit($event)">
      </app-prod-pd-new-edit>
      <app-prod-pd-new-edit class="component-in-row" *ngFor="let paisDenominacion of listaPaisesDenominacion" [paisDenominacion]="paisDenominacion"
      [paisId]="paisDenominacion.paisId" [denominacionId]="paisDenominacion.denominacionId" [productorId]="productorId" [editable]="paisDenominacion === editables"
      (refresh)="refresh($event)" (editableChanged)="editableChanged($event)" (pushMessage)="pushMessage.emit($event)">
      </app-prod-pd-new-edit>
  </tbody>
  <tfoot *ngIf="!listaPaisesDenominacion || (listaPaisesDenominacion && listaPaisesDenominacion.length < 1)">
      <tr>
        <td colspan="8">
          {{ 'global.noContent' | translate }}
        </td>
      </tr>
  </tfoot>
</table>
  <!-- <app-paginator *ngIf="listaPaisesDenominacion && listaPaisesDenominacion.length > 0" [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
  </app-paginator> -->
